<template>
  <el-dialog
    title="删除确认"
    :visible.sync="dialogVisible"
    width="30%"
    center
  >
    <div style="text-align: center;">
      <p>确定删除该拼团设置吗？</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="confirmDelete">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteGroupBuySetting } from '@/api/goods/groupBuySettingApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteGroupBuySetting',
  data() {
    return {
      dialogVisible: false,
      deleteInfo: {}
    }
  },
  methods: {
    open(row) {
      this.deleteInfo = { ...row }
      this.dialogVisible = true
    },
    async confirmDelete() {
      try {
        const params = {
          ...this.deleteInfo,
          shopId: getShopId()
        }
        await deleteGroupBuySetting(params)
        this.$message.success('删除成功')
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('删除拼团设置失败:', error)
      }
    }
  }
}
</script>